import useMainState from '@/state/useMainState';

const { userProperties, propertyId } = useMainState();

const getPropertyData = (pid = propertyId.value) => userProperties.value
  .filter((p) => p.propertyId === pid)[0] || {};

export default getPropertyData;
